export const tokenKey = 'Admin-Token'
export const usernameKey = 'Admin-Username'
export const userIdkey = 'Admin-UserId'
export const userIsRoot = 'Admin-Roote'
export const setValue = (key, val) => {
	sessionStorage.setItem(key, val)
}
export const getValue = key => {
	return sessionStorage.getItem(key)
}
export const removeValue = key => {
	sessionStorage.removeItem(key)
}
